import { analytics_overview_route, VITE_API_URL } from "@/constants";
import type { AuthFetchParams } from "./global";
import { queryOptions } from "@tanstack/react-query";
import type { AnalyticsOverview } from "@/lib/types";
import { timeZone, type DateRange } from "@/lib/date-range";

type AnalyticsParams = AuthFetchParams & { range: DateRange };

async function getAnalyticsOverview(params: AnalyticsParams) {
  const query = new URLSearchParams({
    start: params.range.start.toISOString(),
    end: params.range.end.toISOString(),
    tz: timeZone(),
  });
  const res = await fetch(
    `${VITE_API_URL}${analytics_overview_route}?${query}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${params.token}`,
        "X-Inventoree-Organization": params.orgId,
      },
      credentials: "include",
    },
  );

  const access = res.headers.get("access-token");
  if (access) params.setToken(access);

  if (!res.ok) throw new Error(`analytics overview: ${res.status}`);
  return (await res.json()) as AnalyticsOverview;
}

export const analyticsQueryOpts = (params: AnalyticsParams) =>
  queryOptions({
    queryKey: [
      params.orgId,
      "analytics",
      "overview",
      params.range.start.toISOString(),
      params.range.end.toISOString(),
    ],
    queryFn: async () => await getAnalyticsOverview(params),
    staleTime: 60 * 1000,
  });
